import { Button, CardActions, Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/styles';
import moment from 'moment';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ListInfo } from '../../tabs/ProfileTab';

export default function AppointmentCard({
    name,
    date,
    remaining,
    link,
    available,
}) {
    const theme = useTheme();
    const navigate = useNavigate();
    const from = moment(available[0]).format('h:mm a');
    const to = moment(available[available.length - 1]).format('h:mm a');
    const duration = `${from} - ${to}`;

    return (
        <Grid item xs={12}>
            <Card
                variant="outlined"
                style={{
                    borderRadius: theme.shape.borderRadius,
                    borderWidth: 2,
                }}
            >
                <CardContent>
                    <Typography style={{ fontWeight: 'bold' }} variant="h6">
                        {name}
                    </Typography>
                    <Grid container spacing={1}>
                        <ListInfo
                            xs={6}
                            icon="eva:clock-outline"
                            label={duration}
                        />
                        <ListInfo
                            xs={6}
                            icon="eva:calendar-outline"
                            label={moment(date).format('DD MMM YYYY')}
                        />
                    </Grid>
                    <Typography>{remaining} Spaces available</Typography>
                </CardContent>
                <CardActions style={{ justifyContent: 'center' }}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => navigate(link)}
                    >
                        Boook Appointment
                    </Button>
                </CardActions>
            </Card>
        </Grid>
    );
}
